// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1VGKF","addWidgetButton":"Header_addWidgetButton__2q_io","dashboardTabs":"Header_dashboardTabs__1jQlC","active":"Header_active__Szonl"};